import { JSX } from "react";

export function getComparisonChangeElement(changeNum: number, formatter?: (num: number) => string): JSX.Element {
  let changeDisp = null;
  const changeNumDisp = !!formatter ? formatter(changeNum) : changeNum;
  if (changeNum > 0) {
    changeDisp = (<div className="text-success">{changeNumDisp}<i className="fa fa-arrow-up ms-1 mb-1"></i></div>);
  } else if (changeNum < 0) {
    changeDisp = (<div className="text-danger">{changeNumDisp}<i className="fa fa-arrow-down ms-1 mb-1"></i></div>);
  } else {
    changeDisp = (<div>{changeNumDisp}<i className="fa fa-arrows-h ms-1 mb-1"></i></div>);
  }
  return changeDisp;
}
